import { makeStyles } from '@mui/styles';

import modalStyles from '../styles';

export default makeStyles(modalStyles);